import { CheckCircle2 } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { Button } from '../../components/Button';
import { ScreenHeader } from '../../components/ScreenHeader';
import { B2BForm } from './B2BForm';
import { useI18n } from '../../i18n/I18nProvider';

export function B2BRequestScreen({ sessionId, username, firstName, source, onPrepare, onBack }: {
  sessionId: string; username: string; firstName: string; source: string; onPrepare: () => Promise<void>; onBack: () => void;
}) {
  const { t } = useI18n();
  const [prepareState, setPrepareState] = useState<'loading' | 'ready' | 'error'>('loading');
  const [prepareAttempt, setPrepareAttempt] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const prepareRef = useRef(onPrepare);
  const translateRef = useRef(t);
  useEffect(() => { prepareRef.current = onPrepare; translateRef.current = t; }, [onPrepare, t]);
  useEffect(() => {
    let active = true;
    setPrepareState('loading');
    setError('');
    void Promise.resolve().then(() => prepareRef.current()).then(() => {
      if (!active) return;
      setPrepareState('ready');
    }).catch((cause: unknown) => {
      if (!active) return;
      setError(cause instanceof Error && cause.message === 'b2b_prepare_timeout' ? translateRef.current('b2b.prepareTimeout') : translateRef.current('b2b.prepareError'));
      setPrepareState('error');
    });
    return () => { active = false; };
  }, [prepareAttempt]);
  return <main className="screen"><ScreenHeader title={t('b2b.requestTitle')} onBack={onBack} /><div className={`screen-content b2b-request-screen${submitted ? ' is-submitted' : ''}`}>
    {submitted ? <section className="success-card"><CheckCircle2 /><p className="eyebrow">{t('b2b.received')}</p><h1>{t('b2b.thanks')}</h1><p>{t('b2b.saved')}</p></section> : <div className="b2b-request-group">
      <div className="section-heading"><div><p className="eyebrow">{t('b2b.about')}</p><h1>{t('b2b.tell')}</h1></div><p>{username ? t('b2b.replyUser', { username }) : t('b2b.replyContact', { name: firstName || t('common.friend') })}</p></div>
      {prepareState === 'error' && <div className="b2b-prepare-error"><p className="inline-error" role="alert">{error}</p><Button type="button" variant="secondary" onClick={() => setPrepareAttempt((current) => current + 1)}>{t('common.retry')}</Button></div>}
      {prepareState === 'loading' && <div className="state-screen"><span className="spinner" />{t('b2b.preparing')}</div>}
      {prepareState === 'ready' && <B2BForm sessionId={sessionId} username={username} source={source} onSuccess={() => setSubmitted(true)} />}
    </div>}
  </div></main>;
}
